import React from "react";

export type TGeminiIconProps = React.SVGAttributes<SVGElement>;

export function GeminiIcon({ ...rest }: TGeminiIconProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...rest}>
      <path fillRule="evenodd" clipRule="evenodd" d="M11.0399 19.32C11.6801 20.78 12.0002 22.34 12.0002 24C12.0002 
      22.34 12.3101 20.78 12.9301 19.32C13.5699 17.86 14.43 16.59 15.5099 15.51C16.5903 14.43 17.86 13.58 19.32 12.96C20.78 
      12.32 22.3403 12 24 12C22.3403 12 20.78 11.69 19.32 11.07C17.86 10.43 16.5903 9.57 15.5099 8.49003C14.43 7.41 13.5699 
      6.14001 12.9301 4.68C12.3101 3.22 12.0002 1.66 12.0002 0C12.0002 1.66 11.6801 3.22 11.0399 4.68C10.4202 6.14001 9.57 
      7.41 8.49011 8.49003C7.41021 9.57 6.14003 10.43 4.68001 11.07C3.22 11.69 1.66015 12 0 12C1.66015 12 3.22 12.32 4.68001 
      12.96C6.14003 13.58 7.41021 14.43 8.49011 15.51C9.57 16.59 10.4202 17.86 11.0399 19.32Z" fill="url(#paint0_linear_3615_2825)" />
      <defs>
        <linearGradient id="paint0_linear_3615_2825" x1="23.4029" y1="2.3435" x2="6.99845" y2="18.0451" gradientUnits="userSpaceOnUse">
          <stop stopColor="#BD688B" />
          <stop offset="1" stopColor="#817BD0" />
        </linearGradient>
      </defs>
    </svg>

  );
}
